import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useHistoryContext } from "~/routes/context/index.js";
import { getLoggedUserId } from "~/store/selectors/selector.users";
import PageBody from "./PageBody.jsx";
import PageHeader from "./PageHeader.jsx";
import PageLoader from "./PageLoader.js";
import { getUpdateHideNotifications } from "../../store/selectors/selector.configOptions.jsx";
import { usePageTitle, useUnreadCount } from "../Hooks";

export const Page = ({ children, className, title, id, overrideLastIfContains }) => {
  const { pushToState } = useHistoryContext();
  const { pathname, search } = useLocation();
  const loggedUserId = useSelector(getLoggedUserId);
  const updatesHideNotifications = useSelector(getUpdateHideNotifications);
  const totalUnreadUpdates = useUnreadCount(!!loggedUserId);

  usePageTitle(title, !updatesHideNotifications ? totalUnreadUpdates : 0);

  useEffect(() => {
    if (typeof pushToState === "function") {
      pushToState({
        pathname: `${pathname}${search}`,
        title,
        overrideLastIfContains,
      });
    }
  }, [title, pathname, search, pushToState, overrideLastIfContains]);

  return (
    <div
      id={id}
      data-page-title={title}
      className={classNames("tw-flex tw-flex-col tw-grow", className)}
    >
      {children}
    </div>
  );
};

Page.Header = PageHeader;
Page.Body = PageBody;
Page.Loader = PageLoader;

Page.propTypes = {
  object: PropTypes.any,
  title: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  overrideLastIfContains: PropTypes.string,
};
